<template>

    <form ref="contacorrentecarteira-form-edit" v-on:submit.prevent="executeEdit(model)" novalidate>

        <div class="row">

            <div class="form-group col-md-12">
                <label for="codigoCedente">Código de Cedente</label>
                <input type="text" class="form-control" name="codigoCedente" placeholder="Código de Cedente" v-model="model.codigoCedente" required />
            </div>
            <div class="form-group col-md-6">
                <label for="nossoNumeroInicial">Nosso Número Incremental</label>
                <input type="text" class="form-control" name="nossoNumeroInicial" placeholder="Nosso Número Incremental" v-model="model.nossoNumeroInicial" required />
            </div>
            <div class="form-group col-md-6">
                <label for="numeroRemessaInicial">Nº Remessa Inicial</label>
                <input type="text" class="form-control" name="numeroRemessaInicial" placeholder="Nº Remessa Inicial" v-model="model.numeroRemessaInicial" required />
            </div>
            <div class="form-group col-md-6">
                <div class="clearfix">&nbsp;</div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="cNAB" class="custom-control-input" v-model="model.cnab">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> CNAB?</span>
                </label>
            </div>
            <div class="form-group col-md-6">
                <div class="clearfix">&nbsp;</div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="ativa" class="custom-control-input" v-model="model.ativa">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> Ativa?</span>
                </label>
            </div>
            <div class="form-group col-md-6">
                <div class="clearfix">&nbsp;</div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="principal" class="custom-control-input" v-model="model.principal">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> Principal?</span>
                </label>
            </div>
            <div class="form-group col-md-6">
                <div class="clearfix">&nbsp;</div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="bancoEmite" class="custom-control-input" v-model="model.bancoEmite">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> Banco Emite Boleto?</span>
                </label>
            </div>


        </div>

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="executeEdit(model)">
            <span>Salvar</span>
        </button>

    </form>


</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "contacorrentecarteira-form-edit",
        mixins: [base],
        props: { id: Number },
        data: () => ({

            model: {},

            form: "contacorrentecarteira-form-edit",

            resources: {
                edit: 'contacorrentecarteira',
            },

        }),

        methods: {

            executeEdit: function (model) {

                if (this.formValidate() == false) return;

                new Api(this.resources.edit).put(model).then(data => {
                    this.defaultSuccessResult("Edição realizada com sucesso");
                    this.$emit('on-saved', data)
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            onBack: function () {
                this.$emit('on-back')
            }
        },

        mounted() {
            new Api(this.resources.edit).get({ contaCorrenteCarteiraId: this.id }).then(data => {
                if (data.data) this.model = data.data;
                else if (!data.dataList) this.model = {};
                else if (data.dataList.length == 1) this.model = data.dataList[0];
                else this.model = {};
            }, err => {
                this.defaultErrorResult(err);
            })
        }
    };
</script>